<script lang="ts">
  import { type Snippet } from "svelte"
  import { Loader } from "lucide-svelte"

  let {
    processing = $bindable(),
    disabled = false,
    class: css,
    onclick,
    children
  }: {
    processing: boolean
    disabled?: boolean
    class?: string
    onclick?: () => void
    children: Snippet
  } = $props()
</script>

<button
  disabled={processing || disabled}
  class={css || ""}
  type="button"
  {onclick}
>
  {#if processing}
    <Loader class="rotate" />
  {:else}
    {@render children()}
  {/if}
</button>
